export const ONE_SIGNAL_APP_ID = '6d213b17-00f9-4837-bce7-3187440ea3b7';
export const GOOGLE_TAG_MANAGER_ID = 'G-LNR2NHC3ZX';

// Font Families
export const DEFAULT_FONT_FAMILY = 'Stag Sans LC';
export const DEFAULT_FONT_FAMILY_SEMIBOLD = 'Stag Sans LC Semibold';
